// MobileGrid — grade vertical de cards (touch). Parede A5.
//
// Substituto mobile dos grids da TV (que navegam por setas com auto-scroll).
// Aqui é SCROLL VERTICAL NATIVO da própria aba (o MobileShell já scrolla o
// <main>): só dispomos os cards numa grade responsiva via CSS grid. Sem foco,
// sem virtualização (catálogo mobile pagina/limita; ver MobileMovies). As
// imagens dos cards são lazy (Poster loading="lazy" por padrão).
//
// Componente "burro" de layout: recebe os cards já montados (MobileVodCard).

import type { ReactNode } from 'react'

import styles from './MobileGrid.module.css'

export interface MobileGridProps {
  children: ReactNode
  /** data-grid pros testes localizarem a grade. */
  gridId: string
}

export function MobileGrid({ children, gridId }: MobileGridProps): JSX.Element {
  return (
    <div className={styles.grid} data-grid={gridId}>
      {children}
    </div>
  )
}
